import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DictionaryPipe } from './dictionary.pipe';
import { MultiLangDictPipe } from './multiLangDict.pipe';
import { AppNamePipe } from './appNameDict.pipe';




@NgModule({
  declarations: [DictionaryPipe, MultiLangDictPipe, AppNamePipe],
  imports: [
    CommonModule
  ],
  exports: [DictionaryPipe, MultiLangDictPipe, AppNamePipe]
})
export class PipesModule { }
